import { useState } from "react";
import SidebarLogin from "./SidebarLogin";
import SpinnerCuadrado from "../../modules/helpers/SpinnerCuadrado";

const SidebarButton = ({
  infoApi,
  setShowModalSuccess,
  setShowModalActivaSuccess,
  setObjUsuarioLogin,
}) => {
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleShow = () => setShow(true);

  return (
    <>
      {loading && <SpinnerCuadrado />}
      <div className="sticky__btn__sidebar d-lg-block d-md-block d-none">
        <button className="btn__sidebar" type="button" onClick={handleShow}>
          <b>
            INGRESA A TU
            <br />
            ECOSISTEMA AQUÍ
          </b>
          <i className="fa-solid fa-angle-up flecha__sticky__btn"></i>
        </button>

        <SidebarLogin
          infoApi={infoApi}
          show={show}
          setShow={setShow}
          setShowModalSuccess={setShowModalSuccess}
          setShowModalActivaSuccess={setShowModalActivaSuccess}
          setObjUsuarioLogin={setObjUsuarioLogin}
          setLoading={setLoading}
        />
      </div>
    </>
  );
};

export default SidebarButton;
